// Secteurs.jsx
import '../styles/Secteurs.css';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import MapSelector from '../components/MapSelector';
import { API } from '../config/api';

export default function Secteurs() {
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ nom: '', latitude: '', longitude: '', coords: [] });
  const [secteurs, setSecteurs] = useState([]);

  const token = localStorage.getItem('token');

  const fetchSecteurs = async () => {
    try {
      const res = await axios.get(API+'/api/secteurs', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSecteurs(res.data);
    } catch (err) {
      console.error("Erreur chargement secteurs :", err);
    }
  };

  useEffect(() => {
    fetchSecteurs();
  }, []);

  const filtered = secteurs.filter(s =>
    s.nom.toLowerCase().includes(search.toLowerCase())
  );

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        ...form,
        latitude: parseFloat(form.latitude),
        longitude: parseFloat(form.longitude),
        coords: form.coords
      };

      if (editingId) {
        await axios.put(API+`/api/secteurs/${editingId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axios.post(API+'/api/secteurs', payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }

      setForm({ nom: '', latitude: '', longitude: '', coords: [] });
      setEditingId(null);
      setShowModal(false);
      fetchSecteurs();
    } catch (err) {
      console.error("Erreur enregistrement secteur :", err);
    }
  };

  const handleEdit = (secteur) => {
    setForm({
      nom: secteur.nom,
      latitude: secteur.latitude?.toString() || '',
      longitude: secteur.longitude?.toString() || '',
      coords: secteur.coords || []
    });
    setEditingId(secteur.ids);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(API+`/api/secteurs/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      fetchSecteurs();
    } catch (err) {
      console.error("Erreur suppression secteur :", err);
    }
  };

  return (
    <div className="secteur-page-container">
      <h1>Gestion des Secteurs</h1>

      <div className="secteur-header">
        <input
          type="text"
          placeholder="Rechercher un secteur..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button className="secteur-btn-add" onClick={() => {
          setShowModal(true);
          setEditingId(null);
          setForm({ nom: '', latitude: '', longitude: '', coords: [] });
        }}>
          + Ajouter Secteur
        </button>
      </div>

      <table className="secteur-table">
        <thead>
          <tr>
            <th>Nom du secteur</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((s, i) => (
            <tr key={i}>
              <td>{s.nom}</td>
              <td>
                <button className="secteur-btn-edit" onClick={() => handleEdit(s)}><FaEdit /></button>
                <button className="secteur-btn-delete" onClick={() => handleDelete(s.ids)}><FaTrashAlt /></button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="secteur-modal-overlay">
          <div className="secteur-modal">
            <h2>{editingId ? "Modifier Secteur" : "Ajouter un Secteur"}</h2>
            <form onSubmit={handleSubmit}>
              <input
                name="nom"
                value={form.nom}
                onChange={handleChange}
                type="text"
                placeholder="Nom du secteur"
                required
              />
              <input
                name="latitude"
                value={form.latitude}
                onChange={handleChange}
                type="number"
                step="0.000001"
                placeholder="Latitude"
                required
              />
              <input
                name="longitude"
                value={form.longitude}
                onChange={handleChange}
                type="number"
                step="0.000001"
                placeholder="Longitude"
                required
              />

              <MapSelector
                position={
                  form.latitude && form.longitude
                    ? { lat: parseFloat(form.latitude), lng: parseFloat(form.longitude) }
                    : null
                }
                zone={form.coords || []}
                existingZones={secteurs
                  .filter(s => s.ids !== editingId && Array.isArray(s.coords) && s.coords.length > 0)
                  .map(s => s.coords)
                }
                onSelect={(position, zone) =>
                  setForm(f => ({
                    ...f,
                    latitude: position.lat.toFixed(6),
                    longitude: position.lng.toFixed(6),
                    coords: zone
                  }))
                }
              />



              <div className="secteur-modal-actions">
                <button type="submit">Enregistrer</button>
                <button type="button" onClick={() => setShowModal(false)}>Annuler</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <footer className="page-footer">
        <p>© 2025 Abar. Powered by <strong>Jysser Connect</strong></p>
      </footer>
    </div>
  );
}
